import { RouterProvider } from 'react-router-dom';
import { router } from './screens/Routes/routes';

const App = () => {
    /**
     * Environment variable to determine whether the ILETS logo should be displayed or not in the application.
     * Which is managed by the the pipeline environment variable
     */
    const showILETSLogo = process.env.REACT_APP_SHOW_LOGO ?? 'false';

    /**
     * UpdateFavicon is the function that changes the favicon icon for the browser tab.
     * @param iconPath is the path to the icon file to set to the browser tab icon.
     * which will be changed based on the current environment eg. DEV, QA, PROD etc .
     */
    const updateFavicon = (iconPath: string) => {
        const link: any = document.querySelector("link[rel='icon']");
        if (link) {
            link.href = iconPath;
        } else {
            const newLink = document.createElement('link');
            newLink.rel = 'icon';
            newLink.href = iconPath;
            document.head.appendChild(newLink);
        }
    };
    /**
     * Set favicon and title of the applcation tab based on the showILETSLogo boolean value.
     * Default react app logo is used in the development environment by default.
     * Note: Make sure the ILETSLogo.svg must be present in the public folder.
     */
    if (showILETSLogo === 'true') {
        updateFavicon('/ILETSLogo.svg');
        document.title = 'ICMST';
    }

    return <RouterProvider router={router} />;
};

export default App;
